<template>
  <div class="flex max-w-96 flex-col justify-between rounded-lg px-4 pb-4 pt-2">
    <div class="flex w-full">
      <button class="ml-auto flex size-6 min-h-6 min-w-6 cursor-pointer items-center justify-center" @click="map.closePopup()">
        <close-rounded :aria-label="t('BcEIKFwEZZ7082KqKVCFw')" class="*:fill-type-primary" />
      </button>
    </div>
    <p>
      {{ t('TKrefHkFLU9ndqCXUYapN') }}
    </p>
  </div>
</template>

<script setup lang="ts">
import CloseRounded from '@/common/assets/icons/close-rounded.svg';
import { useMapStore } from '@/features';
import { i18n } from '@/locales';

const { t } = i18n.global;
const map = useMapStore();
</script>
